export default "__VITE_IMAGE_ASSET__a85a1a53__";